import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import translate from '../../../../i18n/translate';
import Button from '@material-ui/core/Button';
import "./ClassPolicy.scss";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      // position: "absolute",
      width: "90%",
      // height: "90%",
      backgroundColor: theme.palette.background.paper,
      borderRadius: "10px",
      // padding: "15px 1px 0px 1px"
      // paddingTop: "5px"

    },
    modal : {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  })
);

const ClassPolicy = (props: any) => {
  const classes = useStyles();
  const [modalStyle] = React.useState({ 
    top: "5%", 
    bottom: "5%",
    margin: "auto"
  });

  return (
    <Modal
      open={true}
      className={classes.modal}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <div style={modalStyle} className={classes.paper}>
        <div className="class-policy-head">
          <div className="class-policy-title">{translate("twt_class_policy_title")}</div>
          <IconButton aria-label="delete" color="primary" onClick={() => props.setClassPolicy(false)}>
            <CloseIcon className="close-icon"></CloseIcon>
          </IconButton>
        </div>
        <div className="class-policy-body">
          <p>{translate("twt_class_policy_subHeading")}</p>
          <ol>
            <li>{translate("twt_class_policy_list01")}</li>
            <li>{translate("twt_class_policy_list02_sub1")}<br></br>
            {translate("twt_class_policy_list02_sub2")}<br></br>
            {translate("twt_class_policy_list02_sub3")}</li>
            <li>{translate("twt_class_policy_list03")}</li>
            <li>{translate("twt_class_policy_list04")}</li>
            <li>{translate("twt_class_policy_list05")}</li>
            <li>{translate("twt_class_policy_list06")}</li>
          </ol>
        </div>
        <div className="class-policy-footer">
          <Button color="primary" variant="contained" size="medium"  className="session-view-button" onClick={() => props.setClassPolicy(false)}>{translate("twt_class_policy_ok")}</Button>
        </div>
      </div>
    </Modal>
  );
}

export default ClassPolicy